import axios from 'axios';
import LogUtils from "../utils/LogUtils";
import settings from "../settings/settings";
import BaseService from "./BaseService";
import AuthService from "./AuthService";

class UsersService extends BaseService {

  constructor() {
    super();
    this.TAG = "UsersService";
    this.logUtils = new LogUtils();
  }

  async getUserByEmail(userEmail) {
    let currentUser = {};

    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.GET,
          `${settings.MANAGEMENT_SERVICE_URL}/users-by-email/${userEmail}`,
          this.getDefaultHeaders(true)
        )));

      if (response?.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível retornar o usuário com o email especificado."
        };
      }

      if (!response?.data?.user) {
        return {
          status: -1,
          msg: "Não foi possível retornar o usuário com o email especificado."
        };
      }

      if (!response?.data?.roles) {
        return {
          status: -2,
          msg: "Não foi possível obter os papéis desempenhados pelo usuário com o email especificado."
        };
      }

      currentUser = {
        user: response.data.user,
        roles: response.data.roles
      };

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getUserByEmail", err);
      return {
        status: -3,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "Usuário retornado com sucesso",
      data: currentUser
    };
  }

  async getUserById(userId) {
    let user = {};

    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.GET,
          `${settings.MANAGEMENT_SERVICE_URL}/users/${userId}`,
          this.getDefaultHeaders(true)
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível retornar o usuário com o id especificado."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível retornar o usuário com o id especificado."
        };
      }

      user = response.data;

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to getUserById", err);
      return {
        status: -2,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "Usuário retornado com sucesso",
      data: user
    };
  }

  async updateCurrentUser({ userId, email, profilePicId, firstName, lastName, phone }) {
    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.PUT,
          `${settings.MANAGEMENT_SERVICE_URL}/users`,
          this.getDefaultHeaders(true),
          {
            "userId": userId,
            "profilePicId": profilePicId,
            "firstName": firstName,
            "lastName": lastName,
            "phone": phone
          }
        )));

      if (response.status !== 1) {
        return {
          status: 0,
          msg: response.error ? response.error : "Não foi possível retornar o usuário."
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Não foi possível atualizar o usuário."
        };
      }

      // Update the currentUser
      const getUpdatedUser = await this.getUserByEmail(email);

      if (getUpdatedUser.status !== 1) {
        return {
          status: -2,
          msg: "Não foi possível atualizar o usuário."
        };
      }

      const authService = new AuthService();
      authService.setCurrentUser(getUpdatedUser.data);

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to updateCurrentUser", err);

      return {
        status: -2,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "Usuário atualizado com sucesso."
    };
  }

  async updateAgentUser(agentUserInfo) {
    try {
      const response = this.getResponse(await axios(
        this.getBasicHttpRequest(this.HTTP_METHODS.PUT,
          `${settings.MANAGEMENT_SERVICE_URL}/agent-users`,
          this.getDefaultHeaders(true),
          agentUserInfo
        )));

      if (response.status <= 0) {
        return {
          status: 0,
          msg: "Não foi possível atualizar o usuário"
        };
      }

      if (!response.data) {
        return {
          status: -1,
          msg: "Houve um erro ao processar a operação."
        };
      }

    } catch (err) {
      this.logUtils.logErrorMsg(this.TAG, "Unabled to updateAgentUser", err);

      return {
        status: -2,
        msg: this.parseError(err)
      };
    }

    return {
      status: 1,
      msg: "Usuário atualizado com sucesso."
    };
  }

}

export default UsersService;